// 三种窗口适配
import { ref, watch } from 'vue'
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize({ listenOrientation: false })

const usePlat = () => {
  const isCollapse = ref(false)
  const isSider = ref(true)
  const isMobile = ref(false)
  const isSmallChart = ref(false)
  // console.log(width)
  // alert(width.value)

  watch(
    width,
    () => {
      if (width.value < 1000) {
        isSmallChart.value = true
      } else {
        isSmallChart.value = false
      }

      if (width.value < 768) {
        isMobile.value = true
        isSider.value = false
        isCollapse.value = true
      } else if (width.value >= 768 && width.value < 1200) {
        isMobile.value = false
        isSider.value = false
        isCollapse.value = true
      } else {
        isMobile.value = false
        isSider.value = true
        isCollapse.value = false
      }
    },
    { immediate: true }
  )

  return { isMobile, isSider, isCollapse, isSmallChart }
}

export default usePlat
